import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const OnlineMarketplaceWebsiteDevelopersInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Online Marketplace Website Developers in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Connect Buyers & Sellers</Subheading>}
        heading={
          <Heading>
            Online Marketplace{" "}
            <span tw="text-primary-500">Website Developers</span> in Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset specializes in online marketplace website development
            in **Al Barsha**, crafting robust platforms that connect vendors and
            customers for seamless, scalable commerce.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1612469293568-38a5cdbdb5cc?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your Marketplace"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Powerful Marketplace Solutions"
        description="Our platforms drive multi-vendor success."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Vendor Management",
            description: "Easy tools for seller onboarding.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Systems",
            description: "Grow from local to global.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Transactions",
            description: "Safe payments for all users.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Optimized",
            description: "Seamless on any device.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Features",
            description: "Tailored to your niche.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Experts",
            description: "Local marketplace leaders.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Build</Subheading>}
        heading="Our Marketplace Development Process"
        description={
          <Description>
            We create thriving online marketplaces:
            <ul tw="mt-4 list-disc pl-6">
              <li>Strategy: Define your marketplace goals.</li>
              <li>Design: Craft intuitive vendor and buyer interfaces.</li>
              <li>Development: Build robust multi-vendor functionality.</li>
              <li>Testing: Ensure performance and security.</li>
              <li>Launch: Deploy a scalable platform.</li>
              <li>Support: Optimize based on user feedback.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1526406915894-7bcd65f60845?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1609921141835-710b7fa6e438?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Marketplace Success in Al Barsha"
        description="Our platforms empower commerce."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Vendor Growth",
            description: "45% more active sellers.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Transaction Volume",
            description: "30% increase in sales.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "93% satisfaction rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Connect?</Subheading>}
        heading="Online Marketplace Website Developers in Al Barsha"
        description={
          <Description>
            MilaajBrandset builds powerful online marketplace websites in Al
            Barsha, connecting vendors and customers for thriving commerce.
            Contact us to start your platform today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1532363814356-df99100ae399?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1475873326779-3eae1a9c0d13?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
